import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

import { LzThnxForPurchaseComponent } from "./components/lz-thnxForPurchase.component";

import { LzPurchaseService } from "./services/lz-purchase.service";
import { LzThnxForPurchaseService } from "./services/lz-thnxForPurchase.service";
import { LzPurchaseNewComponent } from "./components/lz-purchase-new/lz-purchase-new.component";
import { NgxCaptchaModule } from 'ngx-captcha';
import { SharingModule } from "../lz-sharing/sharing.module";
import { TextMaskModule } from "angular2-text-mask";

@NgModule({
  declarations: [
    LzThnxForPurchaseComponent,
    LzPurchaseNewComponent
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    CommonModule,
    SharingModule,
    NgxCaptchaModule.forRoot(),
    TextMaskModule,
    TranslateModule
  ],
  providers: [
    LzPurchaseService,
    LzThnxForPurchaseService
  ],
  entryComponents: [
    LzThnxForPurchaseComponent,
    LzPurchaseNewComponent
  ]
})

export class LzPurchaseModule {

}
